import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axiosInstance from "./../../../axios/axiosInstance";
import { notify } from "./../../../utils/notification";
import {logOut} from '../../../utils/helpers/logout'
import * as types from "../../constants";
import apiEndpoints from "../../../axios/api";
import { deleteImageFromFirebase, getFirebaseURL, uploadImageOnFirebase } from "../../../firebase/firebaseFunction";
import { notesFilePath } from "../../../firebase/getFirebasePath";
import { logger } from "../../../utils/logging";



export const getPrelimAssessmentReq = async({data})=>{
    return axiosInstance.get(`${apiEndpoints.GET_PRELIM_ASSESSMENT_API}?user_id=${parseInt(data.guestId)}&user_program_id=${parseInt(data.userProgramId)}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getPrelimAssessment({data}){
    try{
        yield put({ type: types.PRE_ASSESSMENT_LOADING })
        let result = yield call(getPrelimAssessmentReq, {data})
        result.data.prelim_assesment_data["url"] = []
        if(result.statusCode === 200){
            if(result?.data?.prelim_assesment_data?.docs)
                for(let item of result?.data?.prelim_assesment_data?.docs){
                    result.data.prelim_assesment_data.url.push(yield getFirebaseURL(item))
                }
            

            yield put({ type: types.GET_PRE_ASSESSMENT_DATA_SUCCESS, payload: result.data});
        }else{
            yield put({ type: types.GET_PRE_ASSESSMENT_DATA_FALIURE }); 
        }    
    }catch(error){
        logger.log(error)
        yield put({ type: types.GET_PRE_ASSESSMENT_DATA_FALIURE }); 
    }
}


export const deletePrelimAssessmentReq = async({data})=>{
    const BODY = {
        "prelim_assessment_id": data.prelim_assessment_id
      }

    return axiosInstance.delete(apiEndpoints.DELETE_PRELIM_ASSESSMENT_API, { data: {data: BODY} })
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* deletePrelimAssessment({data}){
    try{
        yield put({ type: types.PRE_ASSESSMENT_LOADING })
        let result = yield call(deletePrelimAssessmentReq, {data})

        if(result.statusCode === 200){
            yield put({ type: types.DEL_PRE_ASSESSMENT_DATA_SUCCESS});
            yield put({ type: types.UPDATE_GUEST_LIST, payload: {type: data.type, user_program_id: data.user_program_id, value: 1, keyName: "is_prelim_assessment_completed"}});
            notify("success", result.message)
        }else{
            yield put({ type: types.DEL_PRE_ASSESSMENT_DATA_FALIURE }); 
        }    
    }catch(error){
        logger.log(error)
    }
}

export const addPrelimAssessmentReq = async({data})=>{
    const BODY = {
      "user_id": data.user_id,
      "user_program_id": data.user_program_id,
      "user_height": parseFloat(data.user_height),
      "user_weight": parseFloat(data.user_weight),
      "objectives": data.objectives,
      "is_current_health_complaint": parseInt(data.is_current_health_complaint),
      "health_complaint_keywords": JSON.stringify(data.health_complaint_keywords),
      "is_current_health_complaint_physical": 0,
      "health_complaint_keywords_physical": "",
      "is_current_health_complaint_mental": 0,
      "health_complaint_keywords_mental": "",
      "is_past_medical_history": parseInt(data.is_past_medical_history),
      "past_medical_history": JSON.stringify(data.past_medical_history),
      "is_current_medications": parseInt(data.is_current_medications),
      "current_medications": data.current_medications,
      "is_allergies": parseInt(data.is_allergies),
      "allergies_keywords": data.allergies_keywords,
      "is_allergies_to_chemicals": parseInt(data.is_allergies_to_chemicals),
      "allergies_keywords_to_chemicals": data.allergies_keywords_to_chemicals,
      "family_history": data.family_history,
      "diet": data.diet,
      "recommended_stay_duration": data.recommended_stay_duration,
      "recommended_program": data.recommended_program,
      "medical_reports_requested_for": data.medical_reports_requested_for,
      "specific_request_from_guest": data.specific_request_from_guest,
      "docs": data.docsPath,
      "programme_red_flag": data.programme_red_flag,
      "additional_medical_reports": data.additional_medical_reports,
      "session_notes": data.session_notes,
      "assigned_doctor": data.assigned_doctor || 0,
      "case_study_allow": 0
    }
      return axiosInstance.post(apiEndpoints.ADD_PRELIM_ASSESSMENT_API, { data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* addPrelimAssessment({data}){
    try{
        let docsPath=[]
        for(let i=0; i<data.files.newFiles?.length; i++){
            let filePath = notesFilePath({fileName: data.files.newFiles[i].name});
            yield call(uploadImageOnFirebase, data.files.newFiles[i], filePath)
            docsPath.push(filePath)
        }
        data.docsPath=docsPath;

        let result = yield call(addPrelimAssessmentReq, {data})

        if(result.statusCode === 200){
            window.history.back();
            yield put({ type: types.UPDATE_GUEST_LIST, payload: {type: data.type, user_program_id: data.user_program_id, value: 2, keyName: "is_prelim_assessment_completed"}});
            notify('success', result.message);
        }
        yield put({ type: types.ADD_PRE_ASSESSMENT_DATA_FALIURE});

    }catch(error){
        yield put({ type: types.ADD_PRE_ASSESSMENT_DATA_FALIURE});

        logger.log(error)
    }
}


export const updatePrelimAssessmentReq = async({data})=>{
    const BODY = {
        "id": data.id,
        "user_height": parseFloat(data.user_height),
        "user_weight": parseFloat(data.user_weight),
        "objectives": data.objectives,
        "is_current_health_complaint": parseInt(data.is_current_health_complaint),
        "health_complaint_keywords": JSON.stringify(data.health_complaint_keywords),
        "is_current_health_complaint_physical": parseInt(data.is_current_health_complaint_physical),
        "health_complaint_keywords_physical": JSON.stringify(data.health_complaint_keywords_physical),
        "is_current_health_complaint_mental": parseInt(data.is_current_health_complaint_mental),
        "health_complaint_keywords_mental": JSON.stringify(data.health_complaint_keywords_mental),
        "is_past_medical_history": parseInt(data.is_past_medical_history),
        "past_medical_history": JSON.stringify(data.past_medical_history),
        "is_current_medications": parseInt(data.is_current_medications),
        "current_medications": data.current_medications,
        "is_allergies": parseInt(data.is_allergies),
        "allergies_keywords": data.allergies_keywords,
        "is_allergies_to_chemicals": parseInt(data.is_allergies_to_chemicals),
        "allergies_keywords_to_chemicals": data.allergies_keywords_to_chemicals,
        "family_history": data.family_history,
        "diet": data.diet,
        "recommended_stay_duration": data.recommended_stay_duration,
        "recommended_program": data.recommended_program,
        "medical_reports_requested_for": data.medical_reports_requested_for,
        "specific_request_from_guest": data.specific_request_from_guest,
        "docs": data?.docsPath,
        "programme_red_flag": data.programme_red_flag,
        "additional_medical_reports": data.additional_medical_reports,
        "session_notes": data.session_notes,
        "assigned_doctor": data.assigned_doctor || 0,
        "case_study_allow": parseInt(data.case_study_allow)
      }

    return axiosInstance.put(apiEndpoints.UPDATE_PRELIM_ASSESSMENT_API, { data: BODY})
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            }else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* updatePrelimAssessment({data}){
    try{
        let docsPath=[...data.files.uploadedFiles]
        for(let i=0; i<data.files.newFiles?.length; i++){
            let filePath = notesFilePath({fileName: data.files.newFiles[i].name});
            yield call(uploadImageOnFirebase, data.files.newFiles[i], filePath)
            docsPath.push(filePath)
        }

        for(let i=0; i<data.files.removedUploadedFiles?.length; i++){
            let filePath = data.files.removedUploadedFiles[i];
            yield call(deleteImageFromFirebase, filePath)
        }

        data.docsPath=docsPath;

        let result = yield call(updatePrelimAssessmentReq, {data})

        if(result.statusCode === 200){
            window.history.back();
            notify('success', result.message);
        }    
        yield put({ type: types.UPDATE_PRE_ASSESSMENT_DATA_SUCCESS});

    }catch(error){
        logger.log(error)
        yield put({ type: types.UPDATE_PRE_ASSESSMENT_DATA_FALIURE }); 
    }
}


export async function downloadPreArrivalConsultationReq(action) {
    return axiosInstance.get(`${apiEndpoints.DOWNLOAD_PRE_ARRIVAL_CONSULTATION_PDF_API}?user_id=${action.data?.guestId}&user_program_id=${action.data?.userProgramId}${action.data?.user_self_assessment_id? `&user_self_assessment_id=${action.data.user_self_assessment_id}`: ''}`, {
        responseType: 'arraybuffer',
    })
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* downloadPreArrivalConsultation(action) {
    try {
        const result = yield call(downloadPreArrivalConsultationReq, action);
        if (result.data instanceof ArrayBuffer) {
            action.data?.onSuccessCallback?.(result.data)
            yield put({ type: types.DOWNLOAD_PRE_ARRIVAL_CONSULTATION_PDF_SUCCESS }); 

        }else{
            notify('Unable to download sheet.')
            yield put({ type: types.DOWNLOAD_PRE_ARRIVAL_CONSULTATION_PDF_FALIURE }); 

        }
    } catch (e) {
        yield put({ type: types.DOWNLOAD_PRE_ARRIVAL_CONSULTATION_PDF_FALIURE }); 

    }
}


export const getHealthCategoryListReq = async({data})=>{
    return axiosInstance.get(`${apiEndpoints.GET_HEALTH_CATEGORY_LIST_API}`)
        .then(response => {
            return response;
        }).catch((errors) => {
            logger.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                logger.log(errors.response.data.message);
            } else if(errors.response.data.statusCode === 401){
                logOut();
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}

function* getHealthCategoryList({data}){
    try{
        let result = yield call(getHealthCategoryListReq, {data})
        if(result.statusCode === 200){                

            yield put({ type: types.GET_HEALTH_CATEGORY_LIST_SUCCESS, payload: result.data});
        }else{
            yield put({ type: types.GET_HEALTH_CATEGORY_LIST_FALIURE }); 
        }    
    }catch(error){
        logger.log(error)
        yield put({ type: types.GET_HEALTH_CATEGORY_LIST_FALIURE }); 
    }
}


export const getTeamMemberListReq = async({data})=>{
  return axiosInstance.get(`${apiEndpoints.GET_TEAM_MEMBERS_LIST_API}?filter_type=${data.filterType}`)
      .then(response => {
          return response;
      }).catch((errors) => {
          logger.log("errors", errors);
          if (errors.response?.data.statusCode === 400) {
              logger.log(errors.response.data.message);
          } else if(errors.response.data.statusCode === 401){
              logOut();
          } else {
              notify('warning', "Something went wrong");
          }
          return errors
      })
}

function* getTeamMemberList({data}){
  try{
      let result = yield call(getTeamMemberListReq, {data})
      if(result.statusCode === 200){                

          yield put({ type: types.GET_TEAM_MEMBERS_LIST_SUCCESS, payload: result.data});
      }else{
          yield put({ type: types.GET_TEAM_MEMBERS_LIST_FALIURE }); 
      }    
  }catch(error){
      logger.log(error)
      yield put({ type: types.GET_TEAM_MEMBERS_LIST_FALIURE }); 
  }
}


function* prelimAssessmentSaga(){
    yield takeEvery(types.GET_PRE_ASSESSMENT, getPrelimAssessment)
    yield takeEvery(types.DEL_PRE_ASSESSMENT, deletePrelimAssessment)
    yield takeEvery(types.ADD_PRE_ASSESSMENT, addPrelimAssessment)
    yield takeEvery(types.UPDATE_PRE_ASSESSMENT, updatePrelimAssessment)
    yield takeEvery(types.DOWNLOAD_PRE_ARRIVAL_CONSULTATION_PDF, downloadPreArrivalConsultation)
    yield takeLatest(types.GET_HEALTH_CATEGORY_LIST, getHealthCategoryList)
    yield takeLatest(types.GET_TEAM_MEMBERS_LIST, getTeamMemberList)
}

export default prelimAssessmentSaga;